import { rem } from '@heathmont/moon-utils';
import styled from 'styled-components';
import media from '~/client/shared/media';

const Meta = styled.div`
  line-height: normal;
  span {
    opacity: 0.5;
    position: relative;
    display: block;
    font-size: ${rem(12)};
    margin-top: ${rem(4)};
    ${media.desktopSmall} {
      font-size: ${rem(14)};
    }
  }
`;

export default Meta;
